import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { UploadIllustration } from 'assets';
import { useDropzone } from 'react-dropzone';
import { UploadDropZoneProps } from '.';

const DropZoneStyle = styled('div')(({ theme }) => ({
  outline: 'none',
  display: 'flex',
  textAlign: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(5, 1),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.neutral,
  border: `1px dashed ${theme.palette.grey[500_32]}`,
  '&:hover': { opacity: 0.72, cursor: 'pointer' },
  [theme.breakpoints.up('md')]: { textAlign: 'left', flexDirection: 'row' }
}));

export default function UploadDropZone({ error, fileUniqueId, ...other }: UploadDropZoneProps) {
  const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
    ...other
  });
  return (
    <DropZoneStyle
      {...getRootProps()}
      sx={{
        ...(isDragActive && { opacity: 0.72 }),
        ...((isDragReject || error) && {
          color: 'error.main',
          borderColor: 'error.light',
          bgcolor: 'error.lighter'
        })
      }}
    >
      <input data-testid={fileUniqueId} {...getInputProps()} />

      <UploadIllustration sx={{ width: 220 }} />

      <Box sx={{ p: 3, ml: { md: 2 } }}>
        <Typography gutterBottom variant="h5">
          Drop or Select file
        </Typography>

        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Drop files here or click&nbsp;
          <Typography
            variant="body2"
            component="span"
            sx={{ color: 'primary.main', textDecoration: 'underline' }}
          >
            browse
          </Typography>
          &nbsp;through your machine
        </Typography>
        <Typography
          variant="caption"
          sx={{
            mt: 1.5,
            mx: 'auto',
            display: 'block',
            color: 'text.secondary'
          }}
        >
          Allowed only *.jpeg, *.jpg, *.png, *.gif
        </Typography>
      </Box>
    </DropZoneStyle>
  );
}
